/** @format */

var TEST = "test"
var DEV = "dev"
var PROD = "prod"

/**
 * Determine the environment the page is served from based on the page's reported
 * hostname.
 *
 * @param {String} hostname
 * @returns {String|boolean} the environment as a string or false if the environment could be determined
 */
function environment(hostname) {
  if (typeof hostname !== "string") {
    return false;
  }

  var isTest = /\.test\.qless\.com/.test(hostname);
  var isQLess = /\.qless\.com/.test(hostname);
  var isLocal =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    !(isTest || isQLess);
  var isProd = !isTest && !isLocal && isQLess;

  if (isTest) {
    return TEST;
  }

  if (isLocal) {
    return DEV;
  }

  if (isProd) {
    return PROD;
  }

  return false;
}

/**
 *
 * @returns {boolean}
 */
function isProduction() {
  return environment(window.location.hostname) === PROD;
}

function isTest() {
  return environment(window.location.hostname) === TEST;
}

function isDevelopment() {
  return environment(window.location.hostname) === DEV;
}

module.exports = {
  DEV: DEV,
  TEST: TEST,
  PROD: PROD,
  environment: environment,
  isProduction: isProduction,
  isTest: isTest,
  isDevelopment: isDevelopment,
};
